<script>
import forminput from "@/router/views/formcomponet/forminput.vue";
import formtextarea from "@/router/views/formcomponet/formtextarea.vue";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import addedit from "./addedit";
import tlptalep from "@/models/tlptalep";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import useVuelidate from "@vuelidate/core";import { nextTick } from 'vue'
export default {
  mixins: [Api, Sabit, tlptalep],
  page: {
    title: "Talep Oluştur",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    forminput,
    formtextarea,
    addedit, treeselect
  },
  data() {
    return {
      title: "Talep Oluştur",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Talep Oluştur",
          active: true,
        },
      ],
      v$: useVuelidate(),
      FormData: {},
      Belgeler: [],
      PersonelBilgileri: null,
      KaydetButton: false,
      DosyaYukleniyor: false,
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE,
      TALEP_OLUSTUR_BIRIM_SECIMI: JSON.parse(localStorage.getItem('config')).TALEP_OLUSTUR_BIRIM_SECIMI
    };
  },

  watch: {
    "FormData.Ilid"() {
      this.IlceGet()
    }
  },
  methods: {

    IlceGet() {
      if (this.FormData.Ilid) {
        const item = this.FormDataType.Ilid.ComboDataArray.find(item => item.id === this.FormData.Ilid);
        if (item) {
          this.ActionsFilterGet({ Service: "oililce", FullData: true, Filter: "&Ustid=" + item.kod }).then((res) => {
            this.FormDataType.Ilceid.ComboDataArray = res.Data.map(item => ({
              id: item.Id,
              label: item.Value
            }));
          });
        }
      }
    },
    Get() {
      this.KaydetButton = false
    },

    async onSubmit() {

      this.v$.$touch();
      if (!this.v$.FormData.$invalid) {
        this.KaydetButton = true
        this.FormData.Talipsahipuserid = this.TokenUserId
              if(this.APPLICATION_TYPE == "3"){ 
            const today = new Date();
            today.setDate(today.getDate() + 10);
            this.FormData.Tahminibitis = today.toISOString().slice(0, 10); 
          }

          
        var res = await this.Post("tlptalep", this.FormData)
        if (res) {
          if (this.Belgeler.length > 0) {
            var FormData = []
            this.Belgeler.forEach(item => {
              FormData.push({
                Talepid: res,
                Baslik: item.Filename,
                Olusturanid: this.TokenPersonelId,
                Dosyayolu: item.Fileurl
              })
            })
            var tlptalepbelge = await this.PostList("tlptalepbelge/postlist", FormData)
            if (tlptalepbelge) {
              this.Belgeler = []
            }
          }
          this.FormData = JSON.parse(JSON.stringify(this.tlptalepData));
          this.FormData.Olusturanid = this.TokenPersonelId
        }


      }
    },

    FileUpload(event) {
      var file = event.target.files[0];
      if (!file) return;

      let x = file.name;
      var uzanti = x.substr(
        x.lastIndexOf(".") + 1,
        x.length - x.lastIndexOf(".")
      );
      if (uzanti == "png" || uzanti == "jpeg" || uzanti == "jpg" || uzanti == "docx" || uzanti == "xlsx" || uzanti == "pdf") {
        let formData = new FormData();
        formData.append("file", file);
        this.DosyaYukleniyor = true;
        this.ActionsPost({
          Service: "GenericFileUpDownload/UploadFile?pathUrl=Tlp",
          Data: formData,
        }).then((res) => {
          if (res.Succeeded == true) {

            this.Belgeler.push({
              Filename: file.name,
              Fileurl: res.Data.filename,
              dosya_uzantisi: "." + uzanti
            })
            this.$toast.success("Dosya yüklendi");

          } else {
            this.$toast.error("Dosya yüklenmedi!");
          }
        }).finally(() => {
          this.DosyaYukleniyor = false;
          if (this.$refs.file) {
            this.$refs.file.value = null;
          }
        });
      }
      else {
        this.$toast.error("Hatalı Dosya Uzantısı!");
      }
    },
    BelgeSil(index) {
      this.Belgeler.splice(index, 1)
    },
    
  onSelect(node) {
    if (node.label === "TARSUS ÜNİVERSİTESİ") { 
        this.$toast.error("Bu birim seçilemez!");
      nextTick(() => {
        this.FormData.Atananbirimid = null
      })
    }
  }
  },
  created() {
    this.FormData = JSON.parse(JSON.stringify(this.tlptalepData));
    this.FormData.Olusturanid = this.TokenPersonelId


    this.ActionsFilterGet({
      Service: "opersonel",
      FullData: true,
      Filter: "&Id=" + this.TokenPersonelId,
    }).then((res) => {
      this.PersonelBilgileri = res.Data[0];

      if (this.APPLICATION_TYPE == 2) {
        this.FormData.Ilid = this.PersonelBilgileri.Ilid
        this.FormData.Ilceid = this.PersonelBilgileri.Ilceid
        this.FormData.Mahalle = this.PersonelBilgileri.Mahalle
        this.FormData.Adres = this.PersonelBilgileri.Adres
      }
    });

  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-4">
              </div>
              <div class="col-sm-8">
                <div class="text-sm-end"></div>
              </div>
            </div>

            <Form @submit.prevent="onSubmit" v-if="FormData && PersonelBilgileri">

              <div class="row">

                <forminput class="col-lg-6" :FormDataType="FormDataType.Baslik" :Value="FormData.Baslik"
                  :v="v$.FormData.Baslik" @input="FormData.Baslik = $event.target.value" />

                <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Taleptipid.FieldTitle"
                  :key="FormData.Taleptipid">
                  <treeselect :multiple="false" :options="FormDataType.Taleptipid.ComboDataArray"
                    placeholder="Seçiniz..." v-model="FormData.Taleptipid" />
                  <treeselect-value :value="FormData.Taleptipid" />
                  <span v-if="v$.FormData.Taleptipid.$error">{{ $t("ValidationMessage.required") }}</span>
                </b-form-group>


                <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Oncelikid.FieldTitle"
                  :key="FormData.Oncelikid">
                  <treeselect :multiple="false" :options="FormDataType.Oncelikid.ComboDataArray"
                    placeholder="Seçiniz..." v-model="FormData.Oncelikid" />
                  <treeselect-value :value="FormData.Oncelikid" />
                  <span v-if="v$.FormData.Oncelikid.$error">{{ $t("ValidationMessage.required") }}</span>
                </b-form-group>
          

                <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Uygulamaid.FieldTitle"
                  :key="FormData.Uygulamaid" v-if="APPLICATION_TYPE == 1 && TALEP_OLUSTUR_BIRIM_SECIMI != true">
                  <treeselect :multiple="false" :options="FormDataType.Uygulamaid.ComboDataArray"
                    placeholder="Seçiniz..." v-model="FormData.Uygulamaid" />
                  <treeselect-value :value="FormData.Uygulamaid" />
                  <span v-if="v$.FormData.Uygulamaid.$error">{{ $t("ValidationMessage.required") }}</span>
                </b-form-group>


                <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Atananbirimid.FieldTitle"
                  :key="FormData.Atananbirimid" v-if="TALEP_OLUSTUR_BIRIM_SECIMI == true">
                  <treeselect :multiple="false" :options="FormDataType.Atananbirimid.ComboDataArray"
                    placeholder="Seçiniz..." v-model="FormData.Atananbirimid" @select="onSelect" />
                  <treeselect-value :value="FormData.Atananbirimid" />
                </b-form-group>


                <b-form-group class="col-lg-6" label="Birim">
                  <b-form-input v-model="PersonelBilgileri.Birim" disabled="disabled"></b-form-input>
                </b-form-group>

                <b-form-group class="col-lg-6" label="Talebi Açan">
                  <b-form-input v-model="PersonelBilgileri.Adsoyad" disabled="disabled"></b-form-input>
                </b-form-group>

                <b-form-group class="col-lg-6" label="E-Posta">
                  <b-form-input v-model="PersonelBilgileri.Eposta" disabled="disabled"></b-form-input>
                </b-form-group>

                <b-form-group class="col-lg-6" label="Telefon">
                  <b-form-input v-model="PersonelBilgileri.Telefon" disabled="disabled"></b-form-input>
                </b-form-group>

                <div class="col-md-6"></div>

                <b-form-group class="col-lg-6" v-if="APPLICATION_TYPE == 2" label-for="text"
                  :label="FormDataType.Ilid.FieldTitle" :key="FormData.Ilid">
                  <treeselect :multiple="false" :options="FormDataType.Ilid.ComboDataArray" placeholder="Seçiniz..."
                    v-model="FormData.Ilid" />
                  <treeselect-value :value="FormData.Ilid" />
                </b-form-group>

                <b-form-group class="col-lg-6" v-if="APPLICATION_TYPE == 2" label-for="text"
                  :label="FormDataType.Ilceid.FieldTitle" :key="FormData.Ilceid">
                  <treeselect :multiple="false" :options="FormDataType.Ilceid.ComboDataArray" placeholder="Seçiniz..."
                    v-model="FormData.Ilceid" />
                  <treeselect-value :value="FormData.Ilceid" />
                </b-form-group>

                <forminput class="col-lg-6" v-if="APPLICATION_TYPE == 2" :FormDataType="FormDataType.Adres"
                  :Value="FormData.Adres" :v="v$.FormData.Adres" @input="FormData.Adres = $event.target.value" />
                <forminput class="col-lg-6" v-if="APPLICATION_TYPE == 2" :FormDataType="FormDataType.Mahalle"
                  :Value="FormData.Mahalle" :v="v$.FormData.Mahalle" @input="FormData.Mahalle = $event.target.value" />



                <formtextarea class="col-lg-12" :FormDataType="FormDataType.Aciklama" :Value="FormData.Aciklama"
                  :v="v$.FormData.Aciklama" @input="FormData.Aciklama = $event.target.value" />

                <div class="row">
                  <div class="col-md-10">


                    <template class="" v-for="(Data, index) in Belgeler" :key="index">
                      <a target="_blank" :href="FILES_URL + '/Tlp/' + Data.Fileurl">
                        <span style="margin-right: 10px; color: #ff69b4" class="fas fa-file-image"
                          v-if="(Data.dosya_uzantisi == '.png' || Data.dosya_uzantisi == '.jpg' || Data.dosya_uzantisi == '.jpeg')"></span>
                        <span style="margin-right: 10px; color: green" class="fas fa-file-excel"
                          v-if="Data.dosya_uzantisi == '.xlsx'"></span>
                        <span style="margin-right: 10px; color: purple" class="fas fa-file-pdf"
                          v-if="Data.dosya_uzantisi == '.pdf'"></span>
                        <span style="margin-right: 10px; color: blue" class="fas fa-file-word"
                          v-if="Data.dosya_uzantisi == '.docx'"></span>
                      </a>
                      {{ Data.Filename }}
                      <i class="far fa-trash-alt" @click="BelgeSil(index)"></i>
                      &nbsp;&nbsp;&nbsp;
                    </template>
                  </div>
                  <div class="col-md-2">
                    <div class="custom-file-input float-end"> <input ref="file" type="file" @change="FileUpload($event)"
                        :disabled="DosyaYukleniyor" accept=".jpg, .jpeg, .png, .12, .pdf, .docx"> </div>
                    <span v-if="DosyaYukleniyor" class="float-end me-2">Dosya yükleniyor...</span>
                  </div>
                </div>
              </div>

              <button class="btn btn-primary" type="submit" :disabled="KaydetButton || DosyaYukleniyor">
                {{ KaydetButton ? 'Kaydediliyor' : (DosyaYukleniyor ? 'Dosya Yükleniyor...' : 'Kaydet') }}
              </button>
            </Form>
          </div>
        </div>
      </div>
    </div>

    <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
  </Layout>
</template>
